<template>
  <div class="container">
    <b-navbar :is-active="isActive" :close-on-click="false">
      <template slot="burger">
        <b-navbar-item @click="lol">
            <a role="button" class="navbar-burger burger">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </b-navbar-item>
        <b-navbar-item class="brand" tag="router-link" :to="{ path: '/' }">
          <img
            src="../assets/logo.png"
            alt="Enhancify"
          >
        </b-navbar-item>
      </template>
      <template slot="start">
      </template>
      <template slot="end">
        <b-navbar-item href="https://www.enhancify.com/contact-us">
          Contact Us
        </b-navbar-item>
        <b-navbar-item tag="a" class="phone" href="tel:+18134999879">
          <b-icon class="phone__icon" pack="fas" icon="phone-alt" size="is-small"></b-icon>
          <a  class="phone__link">813-499-9879</a>
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'navbar',

  data() {
    return {
      isActive: false,
    };
  },

  methods: {
    lol() {
      if (this.isActive) this.isActive = false;
      else this.isActive = true;
    },
  },

};
</script>

<style scoped lang="stylus">
  .navbar__button
    font-size 14px
    font-weight bold
    border 1px solid #68ba62
    color #68ba62
    border-radius 3px
    cursor pointer
    padding 11px 32px
    background transparent
    line-height 24px
    transition .25s
    &:hover
      background #0acc48
      border 1px solid transparent
      color #fff
  .phone
    margin-left -5px
    padding-left 0
    cursor pointer
    &__icon
      color #8fa7b3
      font-size 16px
      margin-right 10px
      margin-top -2px
    &__link
      color #282828
.navbar-item
  font-size 14px
a.navbar-item
  margin 11px 0 11px 20px
  padding-right 0
  padding-left 0
  &:hover
    color #8fa7b3
    background transparent
.brand.navbar-item
  margin-left 4px
  margin-top 12px
  padding-left 0
.brand.navbar-item img
  width 160px
  margin-right 40px
.sidebar-control-button
  padding 0
</style>
